<template>
    <div
        class="fixed z-40 bg-black/30 w-full h-full flex justify-center items-center px-5 lg:px-0 text-sm lg:text-base"
        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    >
        <div class="w-full lg:w-1/3 h-auto bg-white rounded-lg flex flex-col">
            
            <!-- Header -->
            <div class="h-1/4 w-full bg-gray-300 rounded-t-lg flex justify-between items-center p-5">
                <div>{{ $t('deleteConfirmTitle') }}</div>
                <div @click="$emit('cancelDeletion')">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.2"
                        stroke="white" class="w-6 rounded-full bg-primary p-1">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </div>
            </div>

            <!-- Content -->
            <div class="h-3/4 w-full p-5 flex flex-col justify-center items-center rounded-b-lg space-y-7">
                <div class="text-gray-700 text-center">
                    {{ $t('deleteConfirmMessage') }}
                </div>

                <div class="w-full flex justify-end items-center text-white space-x-3 pt-3 lg:pt-0">
                    <div @click="$emit('cancelDeletion')"
                        class="bg-gray-300 px-3 py-2 rounded-lg text-gray-600 font-medium hover:cursor-pointer hover:bg-gray-200">
                        {{ $t('deleteConfirmCancel') }}
                    </div>
                    <div @click="$emit('confirmDeletion')"
                        class="bg-red-500 px-3 py-2 rounded-lg text-white hover:cursor-pointer hover:bg-red-400">
                        {{ $t('deleteConfirmDelete') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue';

defineEmits([
    "cancelDeletion",
    "confirmDeletion"
]);
</script>
